import { z } from 'zod';
import { paymentMethodSchema, paymentStatusSchema } from './enums.js';

export const initiatePaymentSchema = z.object({
  projectId: z.string().uuid(),
  method: paymentMethodSchema,
  amountHt: z.number().positive().max(1_000_000),
  amountTtc: z.number().positive().max(1_500_000),
});
export type InitiatePaymentInput = z.infer<typeof initiatePaymentSchema>;

export const confirmCardPaymentSchema = z.object({
  paymentId: z.string().uuid(),
  famReference: z.string().trim().min(1).max(120),
});
export type ConfirmCardPaymentInput = z.infer<typeof confirmCardPaymentSchema>;

export const validateBankTransferSchema = z.object({
  paymentId: z.string().uuid(),
  bankReference: z.string().trim().min(1).max(120),
});
export type ValidateBankTransferInput = z.infer<typeof validateBankTransferSchema>;

export const paymentSchema = z.object({
  id: z.string().uuid(),
  projectId: z.string().uuid(),
  method: paymentMethodSchema,
  amountHt: z.number(),
  amountTtc: z.number(),
  status: paymentStatusSchema,
  famReference: z.string().nullable(),
  bankReference: z.string().nullable(),
  paidAt: z.string().datetime().nullable(),
  createdAt: z.string().datetime(),
});
export type Payment = z.infer<typeof paymentSchema>;
